<template>
  <!-- Modal -->
  <modal :close="close">
    <h3 slot="header">{{ $t('reward.remove') }}</h3>
    <div slot="body">
      <div class="modal-body">
        <div class="modal-body">
          <h4>{{ $t("reward.deleteInfo") }}</h4>
        </div>
      </div>
    </div>
    <div slot="footer" style="display: inline">
      <button type="button" @click="removeReward(reward)" class="btn btn-primary">{{ $t("remove") }}</button>
    </div>
  </modal>
</template>

<script>
// API
import rewardsApi from '@/api/v1/rewards';
// COMPONENTS
import Modal from '@/components/Modal';

export default {
  methods: {
    removeReward(reward) {
      rewardsApi.destroyReward(this.$route.params.id, reward.id).then(() => {
        const index = this.rewards.indexOf(reward);
        this.rewards.splice(index, 1);
      });
    },
  },
  props: ['submit', 'close', 'rewards', 'reward'],
  components: { Modal },
};
</script>



// WEBPACK FOOTER //
// Remove.vue?f37d4ef2